export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  CLIENT: '/clients',
  MATTERS: '/matters',
  MATTER_DETAIL: '/matters/detail/:id',
  TIMESHEET: '/timesheets',
  TIMESHEET_LIST: '/timesheets-list',
  TIMESHEET_REVIEW: '/timesheets-review',
  STATISTICS: '/statistics',
  INVOICES: '/invoices',
  // Unified invoicing page (same as invoices, but more descriptive)
  INVOICING: '/invoices',
  CREATE_INVOICE: '/create-invoice',
  AUDIT: '/audit',
  ACTIVITY_LOG: '/audit/activity',
  AUDIT_ANOMALIES: '/audit/anomalies',
  // Legacy: now redirects to AUDIT_ANOMALIES. Kept so old bookmarks / links resolve.
  INVOICE_ANOMALIES: '/invoices/anomalies',
  // Legacy routes for backwards compatibility (now redirect to unified)
  CREDIT_NOTES: '/invoices',
  CREATE_CREDIT_NOTE: '/invoices',
  DOWN_PAYMENTS: '/invoices',
  CREATE_DOWN_PAYMENT: '/invoices',
  USERS: '/users',
  COSTS: '/expenses',
  SETTINGS: '/settings',
  FIRM_SETTINGS: '/firm-settings',
  AML_FORMS: '/aml-forms',
  AML_FORM_PUBLIC: '/aml-forms/public/:token',
  API: {
    BASE: import.meta.env.VITE_API_URL || 'https://server.sentra.be',
    AUTH: {
      LOGIN: '/auth/token/',
    },
    CLIENTS: '/api/clients/',
    MATTERS: '/api/matters/',
    TIMESHEET: '/api/timesheets/',
    TIMESHEET_SUM: '/api/timesheets-sum/',
    TIMESHEET_APPROVE: '/api/timesheets-approve/',
    USERS: '/auth/users/',
    STATISTICS: '/api/stats/',
    COSTS: '/api/costs/',
    // Updated unified invoicing endpoint
    INVOICING_UNIFIED: '/api/invoicing/unified/',
    INVOICE_ANOMALIES: '/api/invoicing/anomalies/',
    AUDIT_ENTRIES: '/api/audit/entries/',
    AUDIT_RESTORE: '/api/audit/entries/restore/',
    // Legacy endpoints (for backwards compatibility)
    INVOICES: '/api/invoicing/unified/',
    CREDIT_NOTES: '/api/credit-notes/',
    DOWN_PAYMENTS: '/api/down-payments/',
    INVOICE_CREDIT_NOTE_APPLICATIONS: '/api/invoice-credit-note-applications/',
    INVOICE_DOWN_PAYMENT_APPLICATIONS: '/api/invoice-down-payment-applications/',
    FIRMS: '/api/firms/',
    AML_FORMS: '/api/aml-forms/',
    AI_ASSISTANT: '/api/ai/',
    FEE_SHARING: '/api/matters/',  // Fee sharing uses matters endpoint: /api/matters/{id}/fee-sharing-configs/
    // Peppol endpoints
    PEPPOL: {
      BASE: '/api/invoicing/peppol',
      CONFIG: '/api/invoicing/peppol/config/',
      PARTICIPANTS: '/api/invoicing/peppol/participants/',
      DOCUMENTS: '/api/invoicing/peppol/documents/',
      WEBHOOK: '/api/invoicing/peppol/webhook/',
      INVOICE_BASE: '/api/invoicing/invoices/',  // For invoice-specific peppol actions
    },
  },
} as const;
